@if (banners()?.length) {
<div class="banner-layouts-section">
    <!-- For layout 10 and banner length greater than and equal to 5 -->
    @if (layout() === 10 && banners().length >= 5) { @if (home_content_section()?.title) {
    <h1>
        {{ home_content_section().title }}
    </h1>
    }
    <horizontal-banner-list [banners]="banners()"></horizontal-banner-list>
    }

    <!-- For other layout -->
    @if (layout() !== 10) { @if (home_content_section()?.title) {
    <h1>
        {{ home_content_section().title }}
    </h1>
    }

    <!-- variant cards list -->
    <div class="variant-listing">
        <div class="row">
            @for (banner of banners(); track banner.id) {
            <banner-variant [banner]="banner" [class]="class()"></banner-variant>
            }
        </div>
    </div>
    }
</div>
}